import React from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";

interface DropzoneProps {
  onClick: () => void;
  onDrag: (event: React.DragEvent<HTMLDivElement>) => void;
  onDrop: (event: React.DragEvent<HTMLDivElement>) => void;
  withVideo?: boolean;
}

const Dropzone: React.FC<DropzoneProps> = ({
  onClick,
  onDrag,
  onDrop,
  withVideo = true,
}) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={onClick}
      css={styles.container}
      onDragOver={onDrag}
      onDragLeave={onDrag}
      onDragEnter={onDrag}
      onDrop={onDrop}>
      <span css={styles.label}>
        {withVideo ? t("issue.addAttachment") : t("issue.addImage")}
      </span>
    </div>
  );
};

const styles = {
  container: css({
    width: "100%",
    height: "246px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px dashed #00ACF5",
    borderRadius: "2px",
    cursor: "pointer",
  }),
  label: css({
    color: "#00ACF5",
    fontSize: "14px",
    fontWeight: 600,
  }),
};

export default Dropzone;
